var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-error",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          deleteOnly: true,
          isTeacher: _vm.isTeacher,
          preview: false,
          defaultGrade: false,
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function fn() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "cw-block-error-content",
                  },
                  [
                    _c("courseware-companion-box", {
                      attrs: {
                        mood: "sad",
                        msgCompanion: _vm.errorMessage,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }